import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useActionInput } from '../../../context';
import { Privacy } from '../types';

export const usePrivacyTooltipText = () => {
	const { privacy } = useActionInput();
	const { t } = useTranslation();

	return useMemo(() => {
		switch (privacy) {
			case Privacy.Public:
				return t('privacy.public_tooltip');
			case Privacy.Private:
				return t('privacy.private_tooltip');
			case Privacy.Team:
				return t('privacy.team_tooltip');
			default:
				return t('privacy.public_tooltip');
		}
	}, [privacy, t]);
};
